/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Message/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Message({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Internal/Content/Mine/Message"
  
}) {
let internalMessageValueData = fromData.useDataFormat({ viewPath,
context: 'internal',
path: 'message',
format: fromFormat.textWithLinks,
})
  return (<React.Fragment
>
<span
  data-testid="Message.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{internalMessageValueData}
</span>
{children}
</React.Fragment>)
}